(() => {
  if (!customElements.get("infinite-scroll")) {
    class t extends HTMLElement {
      constructor() {
        super(), (this.button = this.querySelector("button"));
      }
      connectedCallback() {
        this.button.addEventListener("click", this.load.bind(this));
      }
      load() {
        this.dataset.next &&
          (history.pushState("page", "", this.dataset.next),
          (this.button.textContent = this.button.dataset.loadingText),
          fetch(this.dataset.next)
            .then((t) => t.text())
            .then((t) => {
              let e = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector("[data-collection-dynamic]");
              e.querySelectorAll("product-item").forEach((t) => {
                document.querySelector("[data-collection-list]").appendChild(t);
              });
              let n = e.querySelector("[data-infinite-scroll]");
              (document.querySelector("[data-infinite-scroll]").innerHTML =
                n.innerHTML),
                (this.button.textContent = this.button.dataset.loadMoreText);
            }));
      }
    }
    customElements.define("infinite-scroll", t);
  }
})();
